import { mergeAttributes, Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import ImageUploadView from '@/components/tiptap/views/ImageUpload/ImageUploadView.vue';
import { nanoid } from 'nanoid';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    imageUpload: {
      setImageUpload: () => ReturnType;
    };
  }
}

export const ImageUpload = Node.create({
  name: 'imageUpload',

  isolating: true,

  defining: true,

  group: 'block',

  draggable: true,

  selectable: true,

  inline: false,

  addOptions() {
    return {
      HTMLAttributes: {
        class: `node-${this.name}`,
      },
    };
  },

  addAttributes() {
    return {
      id: {
        default: undefined,
        parseHTML: (element) => element.getAttribute('data-id'),
        renderHTML: (attributes) => ({
          'data-id': attributes.id,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `div.node-${this.name}`,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
  },

  addCommands() {
    return {
      setImageUpload:
        () =>
        ({ commands, tr }) => {
          const { selection } = tr;
          const { $from } = selection;
          const currentNodeNextPos = $from.pos + $from.parent.childCount + 2;
          const targetEndPos = $from.after(1) || currentNodeNextPos;

          return commands.insertContentAt(targetEndPos, {
            type: this.name,
            attrs: {
              id: nanoid(10),
            },
          });
        },
    };
  },

  addNodeView() {
    return VueNodeViewRenderer(ImageUploadView);
  },
});

export default ImageUpload;
